import React, { FC, useCallback, useState } from "react";

import { OnboardingContent, PlaceList, PrimaryAlternateControl, SelectablePlace, type Place } from "@xapp/components";

import { AdvancedSearchStepProps } from "./AdvancedSearchStep";

import { OnboardingProps } from "../../models";

export interface AdvancedSearchResultsStepProps extends AdvancedSearchStepProps {
    onNoPlaceSelected(props: OnboardingProps): void;
    places: Place[];
}

export const AdvancedSearchResultsStep: FC<AdvancedSearchResultsStepProps> = (props) => {
    const { aside, places, onNext, onNoPlaceSelected, onboarding, ...rest } = props;

    const [selectablePlaces, setSelectablePlaces] = useState<SelectablePlace[]>(places);

    const selectedPlaces = selectablePlaces.filter((place) => place.selected);
    const selectedPlace = selectedPlaces[0];
    const hasSelectedPlace = !!selectedPlace;

    const handleSelect = useCallback(
        (place: Place) => {
            setSelectablePlaces(
                selectablePlaces.map((p) => ({
                    ...p,
                    selected: p.placeId === place.placeId,
                }))
            );
        },
        [selectablePlaces]
    );

    const handleNext = useCallback(() => {
        onNext({ ...rest, place: selectedPlace });
    }, [onNext, rest, selectedPlace]);

    const handleNoPlaceSelected = useCallback(() => {
        onNoPlaceSelected({ ...onboarding });
    }, [onNoPlaceSelected, onboarding]);

    // only show top 5 results
    const placesToShow = selectablePlaces.slice(0, 5);

    return (
        <>
            <OnboardingContent>
                <h3>Is one of these your business?</h3>
                <p>Select your business then hit Next</p>

                <div style={{ height: "300px", width: "100%", overflowY: "auto" }}>
                    <PlaceList places={placesToShow} onSelect={handleSelect} />
                </div>

                <PrimaryAlternateControl
                    disabled={{ primary: !hasSelectedPlace }}
                    labels={{ primary: "Next", alternate: "None of these, Move on" }}
                    onPrimary={handleNext}
                    onAlternate={handleNoPlaceSelected}
                />
            </OnboardingContent>
        </>
    );
};
